import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styles from "./OlympiadPrivateQualifier.module.scss";
import { UnderlineLink } from "@climate-science/component-library";
import Image from "next/image";
import PrivImg from "@cs/public/img/olympiad/privateq.png";

const OlympiadPrivateQualifier: FC = () => {
  const { t } = useTranslation("olympiad");

  return (
    <section className={styles.cso22}>
      <h2 className={styles.title}> {t("private-event")} </h2>
      <p className={styles.text}>
        <Trans
          t={t}
          i18nKey="private-event-desc"
          components={[
            <UnderlineLink
              key="0"
              href={"https://olympiad." + process.env.NEXT_PUBLIC_DOMAIN + "/register-private-qualifier"}
              target="_blank"
              rel="noreferrer"
            />
          ]}
        />
      </p>
      <Image
        src={PrivImg}
        alt={t("private-event")}
        width={1920}
        height={975}
      />
    </section>
  );
};

export default OlympiadPrivateQualifier;
